import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Form, Row } from "react-bootstrap";
import Switch from "react-switch";
import { useCreateAssessmentDateMutation, useDeleteAssessmentDateMutation, useGetMdtAssessmentDetailsQuery, useUpdateAssesmentMutation, useUpdateAssessmentDateMutation, useUpdateCheckListStatusMutation } from "store/services/mdt/assessment";

// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

// img
import p1 from "../../../../Assets/images/user.png";
import formIcn from "../../../../Assets/images/formIcn.svg";
import { dateFormat, dateFormatLocal, errorMessageToast, formatString, getAge, getNameInitials, normalizeUrl, successMessageToast, userFullName } from "helpers/common";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useGetNoteQuery } from "store/services/note";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { CLIENT_NOTE_TYPES } from "config/constants";
import { useSelector } from "react-redux";
import { useGetMdtTherapistStatusListQuery, useLazyGetFileUrlQuery } from "store/services/utility";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { Breadcrumbs, CommonSelect, CommonToolTip, CstmPagination, NoRecordFound, NoRecordFoundV2 } from "components/Common/Common";
import { DeleteIcon, DocumentColorIcon, EditIcon, EyeIcon, MinusIcon, PlusIcon, ViewDocumentIcon } from "Assets/icons";
import ChatComponent from "components/Chat";
import NotesComponentV2 from "components/shared/FormComponents/V2/Notes/NotesComponentV2";
import { MDT_ASSESSMENT_LIST } from "config/apiPaths";
import { MDT_CLIENT_DOCUMENTS_LIST, MULTIDISCIPLINARY_SERVICES } from "config/paths";
import moment from "moment";
import { Calendar, CheckCircle, Clock } from "react-feather";
import IconButton from "components/shared/Buttons/IconButton";
import { FieldArray, Formik } from "formik";
import { array, object } from "yup";
import { urlRequiredSchema, urlSchema } from "utils/validation/validationHelpers";
import { compact, isEmpty } from "lodash";
import LoadingButton from "components/shared/LoadingButton";
import AppInputField from "components/shared/FormComponents/AppInputField";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useUpdateMdtAssessmentMutation } from "store/services/mdtCaseload";
import { Edit } from "react-feather";
import ClientAttachments from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachments";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useGetClientDetailReportsListQuery } from "store/services/resource";

const MultidisciplinaryDetail = () => {
  const { id: assessmentId } = useParams();
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);
  const [tableRow, setTableRow] = useState(false);
  const [assignChecklist, setAssignChecklist] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [currentItem, setCurrentItem] = useState(null)
  const [editingAssessmentDates, setEditingAssessmentDates] = useState({});
  const [assessmentDateToDelete, setAssessmentDateToDelete] = useState(null);
  const [expandedClinicianId, setExpandedClinicianId] = useState(null);
  const [showAssessmentDateSuccess, setShowAssessmentDateSuccess] = useState(false);
  const [isEditingLinks, setIsEditingLinks] = useState(false);
  const [updateObject, setUpdateObject] = useState({});
  const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10

  const { data: clientDetails, isLoading, isFetching, refetch } = useGetMdtAssessmentDetailsQuery(assessmentId);
  const caseLoadId = clientDetails?.clientCaseloads?.length && clientDetails?.clientCaseloads[0].id;
  const clientType = clientDetails?.client_detail?.client_type;
  const clientId = clientDetails?.id;
  // const reportsList = clientDetails?.clientResources?.filter((item) => item?.resource_type == 'report') || [];
  const { data: reportsList, isLoading: reportsListLoading, isFetching: reportsListFetching } = useGetClientDetailReportsListQuery({ id: clientId, limit: 10, published: true }, { skip: !clientId });
  const totalRecords = reportsList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  // Admin-uploaded intake forms are not in the reports API; shape them like report rows (admin lists them under Reports too)
  const intakeReports = clientDetails?.clientResources
    ?.filter((item) => item?.type === "report" && item?.module?.startsWith("home_education_intake_form_"))
    ?.map((item) => ({
      ...item,
      assesmentType: { title: item?.attachment_name },
      screening_date: item?.createdAt,
      pdfList: [{ attachment_key: item?.attachment_key }],
    })) || [];
  const reportRows = [...(currentPage === 1 ? intakeReports : []), ...(reportsList?.records || [])];

  const { data: checkListStatusList } = useGetMdtTherapistStatusListQuery();
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
  const [updateCheckListStatus, { isLoading: updateChecklistLoading }] = useUpdateCheckListStatusMutation();
  const [createAssessmentDate, { isLoading: createAssessmentDateLoading }] = useCreateAssessmentDateMutation();
  const [updateAssessmentDate, { isLoading: updateAssessmentDateLoading }] = useUpdateAssessmentDateMutation();
  const [deleteAssessmentDate, { isLoading: deleteAssessmentDateLoading }] = useDeleteAssessmentDateMutation();
  const [updateAssesment, { isLoading: updateAssessmentLoading }] = useUpdateMdtAssessmentMutation();

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleChange = (checked) => {
    setChecked(checked);
  };
  const handleChecklistPop = () => setAssignChecklist(!assignChecklist);
  console.log('currentItem', currentItem)

  useEffect(() => {
    if (!showAssessmentDateSuccess) return undefined;

    const closePopup = setTimeout(() => setShowAssessmentDateSuccess(false), 4000);
    return () => clearTimeout(closePopup);
  }, [showAssessmentDateSuccess]);

  const getAssessmentDateInputValue = (date) => date ? moment(date).format("YYYY-MM-DD") : "";

  const getAssessmentTimeInputValue = (assessmentDateItem) => {
    const time = assessmentDateItem?.assessment_time;
    if (!time) return "";

    const timeOnly = moment(time, ["HH:mm:ss", "HH:mm", "h:mm A"], true);
    return timeOnly.isValid() ? timeOnly.format("HH:mm") : moment(time).format("HH:mm");
  };


  const shareLinkSchema = object().shape({
    doc_share_link: array().of(urlSchema()).optional()
  });

  const handleSubmitShareLink = async (values, { setSubmitting }) => {
    try {
      let isConfirm = await confirmDialogV2({ message: "Are you sure you want to update the shared links?" });
      if (!isConfirm) {
        return;
      }

      setSubmitting(true);
      const newValue = values?.doc_share_link?.length ? values?.doc_share_link.join(",") : "";
      const updateData = { doc_share_link: newValue }
      await updateAssesment({ id: assessmentId, data: updateData }).unwrap();
      setUpdateObject(updateData);
      setIsEditingLinks(false);
      refetch();
    } catch (err) {
      console.error("Error saving shared link", err);
    } finally {
      setSubmitting(false);
    }
  }

  const getAssessmentDates = (item) => {
    const dates = item?.assessmentDates
      || item?.assessment_dates
      || item?.clientCaseloadAssessmentDates
      || item?.clientCaseloadAssessmentDate
      || (Array.isArray(item?.assessment_date) ? item.assessment_date : []);
    return (Array.isArray(dates) ? dates : [dates]).filter(Boolean);
  };

  const handleAssessmentDateCancel = (id) => {
    setEditingAssessmentDates((prev) => ({ ...prev, [id]: false }));
  };

  const handleAssessmentDateSave = async (assessmentDateItem, assessmentDate, assessmentTime) => {
    if (!assessmentDate) return;

    try {
      const result = await updateAssessmentDate({
        assessment_date_id: assessmentDateItem.id,
        assessment_date: assessmentDate,
        assessment_time: assessmentTime || null,
      });

      if (result?.error) return;

      setShowAssessmentDateSuccess(true);
      handleAssessmentDateCancel(assessmentDateItem.id);
      refetch();
    } catch (err) {
      console.error("Error updating assessment date", err);
    }
  };

  const handleCreateAssessmentDate = async (caseloadTherapistId, assessmentDate, assessmentTime, setFieldValue) => {
    if (!assessmentDate) {
      errorMessageToast("Please choose an assessment date.");
      return;
    }

    try {
      const result = await createAssessmentDate({
        caseload_therapist_id: caseloadTherapistId,
        assessment_date: assessmentDate,
        assessment_time: assessmentTime || null,
      });
      if (result?.error) return;

      setShowAssessmentDateSuccess(true);
      setFieldValue("newAssessmentDate", "");
      setFieldValue("assessment_time", "");
      refetch();
    } catch (err) {
      console.error("Error creating assessment date", err);
    }
  };

  const handleDeleteAssessmentDate = async () => {
    if (!assessmentDateToDelete) return;

    try {
      const result = await deleteAssessmentDate({ assessment_date_id: assessmentDateToDelete.id });
      if (result?.error) return;

      successMessageToast(result?.data?.message);
      setAssessmentDateToDelete(null);
      setShowConfirmationModal(false);
      refetch();
    } catch (err) {
      console.error("Error deleting assessment date", err);
    }
  };

  const confirmationHandle = async () => {

    if (modalType === "delete" && assessmentDateToDelete) {
      await handleDeleteAssessmentDate();
      return;
    }

    try {

      let result;
      setShowConfirmationModal(false);

      if (modalType == "update") {

        result = await updateCheckListStatus({
          id: currentItem.id,
          caseload_id: currentItem?.caseload_therapist_id,
          status: currentItem?.new_status,
        });
      };

      if (result?.error) return;
      successMessageToast(result?.data?.message);
      refetch();

    } catch (err) { console.log("Error delete therapist") }
  };

  const handleViewPdf = async (name) => {
    // Draft reports have no PDF yet; don't request a URL for "undefined"
    if (!name) return errorMessageToast("PDF is not available for this report yet.");

    try {

      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) {
      console.error("Error assigning therapist", err);
    }
  }

  const breadcrumbItems = [
    { label: "Multidisciplinary Assessments", path: MULTIDISCIPLINARY_SERVICES },
    { label: userFullName(clientDetails) || "Client Details" },
  ];

  useEffect(() => {
    const update = {};
    if (clientDetails?.client_detail?.clientMdtDetail?.doc_share_link) update["doc_share_link"] = clientDetails?.client_detail?.clientMdtDetail?.doc_share_link == "null" ? " " : clientDetails?.client_detail?.clientMdtDetail?.doc_share_link ? clientDetails?.client_detail?.clientMdtDetail?.doc_share_link : " ";
    // if (clientDetails?.client_detail?.clientMdtDetail?.team_lead) update["team_lead"] = clientDetails?.client_detail?.clientMdtDetail?.team_lead;
    if (clientDetails?.client_detail?.clientMdtDetail?.clinic_date) update["clinic_date"] = clientDetails?.client_detail?.clientMdtDetail?.clinic_date
    if (clientDetails?.client_detail?.clientMdtDetail?.dtc) update["dtc"] = clientDetails?.client_detail?.clientMdtDetail?.dtc;

    setUpdateObject(update);
  }, [clientDetails])

  const mdtStatusLabel = "Active"
  const attachmentSortField = ''
  const isDisabled = false

  return (
    <>
      {/* <AssignChecklistPop
        assignChecklist={assignChecklist}
        setAssignChecklist={setAssignChecklist}
      /> */}
      <ConfirmationPop
        confirmation={showConfirmationModal}
        setConfirmation={setShowConfirmationModal}
        confirmHandler={confirmationHandle}
        type={modalType}
      />
      {showAssessmentDateSuccess && (
        <div className={styles.assessmentDateSuccessOverlay} role="status" aria-live="polite">
          <div className={styles.assessmentDateSuccessPopup}>
            <div><CheckCircle size={30} color="#198754" /></div>
            {/* <div className={styles.assessmentDateSuccessIcon} aria-hidden="true">✓</div> */}
            <p className={styles.assessmentDateSuccessTitle}>Success</p>
            <p className={styles.assessmentDateSuccessMessage}>Please share details in the notes</p>
          </div>
        </div>
      )}
      <AddClientDocumentsModal
        show={clientsDocumentModal}
        setShow={setClientsDocumentModal}
        clientId={clientId}
        refetch={refetch}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          {isLoading ? (
            <LoadingIndicator />
          ) : !clientDetails ? (
            <ErrorComponent />
          ) : (
            <Row>
              {(isFetching || updateAssessmentLoading || getFileLoading || getFileFetching || updateChecklistLoading || createAssessmentDateLoading || updateAssessmentDateLoading || deleteAssessmentDateLoading) && <LoadingOverlay />}
              <Row className="pt-3">
                <Col lg="7">
                  <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                </Col>
                <Col lg="5">

                </Col>
              </Row>

              <div style={{ marginTop: clientDetails?.status == 'active' ? "-10px" : '20px' }}>
                <p>
                  <div className="d-flex align-items-end gap-2 proxima-regular">
                    {/* <div className="cursor-pointer" onClick={() => { !favouriteClientLoading && handleFavouriteClient(clientDetails?.client_detail?.id, clientDetails?.client_detail?.is_favorite ? 0 : 1) }}>{clientDetails?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" /> : <Star />}
                      </div> */}
                    <Row className="w-100 align-items-end">
                      <Col lg='7'>
                        <div className="d-flex gap-3 align-items-end">
                          <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000", fontSize: "20px" }}>
                            {mdtStatusLabel != 'Active' && <div className="text-capitalize">{`${mdtStatusLabel}:`}</div>}{" "}{userFullName(clientDetails)}
                          </p>
                          <div style={{ width: "25%" }} className="reports-v2 classroom-conslutation">
                            <div className="w-100 align-items-center gap-3">
                              {/* <label className="discharge-screen-label mb-0">School</label> */}
                              {/* <CommonSelect
                                placeholder={"Choose one..."}
                                option={statusList?.filter((x) => x?.value != mdtStatusId)}
                                onChange={(e) => handleStatusUpdate(e?.value)}
                                value={statusList?.find((x) => x?.value == mdtStatusId)}
                                // onInputChange={(val) => handleSearch(val)}
                                isFilterV2
                                // isClearable
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    width: "100%",
                                  }),
                                }}
                              // isLoading={schoolsLoading}
                              /> */}
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg='5'>
                        <div className="d-flex align-items-end justify-content-end gap-3">
                          {/* <div onClick={() => navigate(generatePath(CLIENT_ATTENDANCE_LIST, { clientId, clientType }))} className="text-end">
                              <span className="themeBlueV2 cursor-pointer ten ms-2 fw-medium fs-8" style={{ textDecoration: "underline", marginTop: clientDetails?.status != 'active' && "10px" }}>SEE ATTENDANCE DETAILS</span>
                            </div> */}
                          <div style={{ display: "flex", gap: "10px" }}>
                            {
                              <div className="mb-2" style={{ marginLeft: "auto", width: "150px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                                <Row className="mb-1">
                                  <Col lg='12'>
                                    <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                                  </Col>
                                  {/* <Col lg='6'>
                                      <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE OF EXPIRY</h3>
                                    </Col> */}
                                </Row>
                                <Row>
                                  <Col lg='12'>
                                    <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: mdtStatusLabel == 'Active' && "#55A215", fontStyle: !["Active"]?.includes(mdtStatusLabel) && "italic" }}>{mdtStatusLabel}</h2>
                                  </Col>
                                  {/* <Col lg='6'>
                                      <h2 className="black mb-0 forteen  text-start">{clientDetails?.client_detail?.date_of_expiry ? dateFormat(clientDetails?.client_detail?.date_of_expiry, "MMM DD, YYYY") : "--"}</h2>
                                    </Col> */}
                                </Row>
                              </div>
                            }
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </p>
              </div>

              <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                <div className="d-flex align-items-center gap_20">
                  <div className="mt-1" style={{ width: "100%" }}>
                    <div className="d-flex justify-content-between">
                      <div style={{ display: "inline-flex" }} className="date-title justify-content-between">
                        <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px" }}>CLIENT INFORMATION</h6>
                        <div className="d-flex align-items-center gap-2">
                          {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                          <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(clientDetails?.record?.reportsPreflightTeacher)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-5">
                        <div>
                          <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE OF BIRTH</h5>
                          <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                        </div>
                        <div>
                          <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>GENDER</h5>
                          <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.gender || "--"}</p>
                        </div>
                        <div>
                          <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>CITY/TOWN</h5>
                          <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.city_town || "--"}</p>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-4">
                        <div>
                          <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>GRADE</h5>
                          <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                        </div>
                        <div>
                          <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>AGE</h5>
                          <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex pt-3 align-items-center gap_20">
                  <div className="mt-1" style={{ width: "100%" }}>
                    <div className="date-title d-flex justify-content-between">
                      <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>PRACTITIONER INFORMATION</h6>
                    </div>
                    <div className="d-flex align-items-center gap-5">
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>PRACTITIONER</h5>
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{formatString(clientDetails?.client_detail?.clientMdtDetail?.specialization == 'pediatrician' ? 'Physician' : clientDetails?.client_detail?.clientMdtDetail?.specialization)}</p>
                      </div>
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DTC #</h5>
                        <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.clientMdtDetail?.dtc || "--"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  clientType == 'school' &&
                  <div className="d-flex pt-3 align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="date-title d-flex justify-content-between">
                        <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>SCHOOL</h6>
                      </div>
                      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>SCHOOL DIVISION</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_school_detail?.client_school_division?.title || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>SCHOOL</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_school_detail?.client_school?.name || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-4">
                          {/* <div>
                                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CLASS ID</h5>
                                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.client_detail?.grade || "--"}</p>
                                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <div className="d-flex align-items-center gap_20">
                  <div className="mt-1" style={{ width: "100%" }}>
                    {
                      clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => index <= 1 && <>
                        <div className="date-title d-flex justify-content-between pt-3">
                          <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>{clientType != 'school' ? `PARENT ${index + 1}` : index == 0 ? "TEACHER" : "COORDINATOR"}</h6>
                        </div>
                        <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-5">
                            <div>
                              <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                              <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                            </div>
                            <div>
                              <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                              <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                            </div>
                            <div>
                              <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                              <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                            </div>
                          </div>
                        </div>
                      </>)
                    }
                  </div>
                </div>

              </div>

              <Col
                lg="6"
                className=""
              // style={{ borderRight: "1px solid #3da0aa4f" }}
              >
                <Row>
                  {/* <Col lg="12 p-0">
                    <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10 border-bottom p-4">
                      <div className="left">
                        <ul className="list-unstyled mb-0 d-flex align-items-center">
                          <li className="m-0 p-0">
                            <Link
                              className="themeBlue fw-sbold"
                              style={{ textDecoration: "underline" }}
                              to="/manage-mdt/multidisciplinary-assessment"
                            >
                              Client
                            </Link>
                          </li>
                          <li className="">
                            <h5 className="m-0 fw-bold themeBlue">
                              / MDT Details
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col> */}
                  {/* <Col lg="12" className="my-3 ps-3 pe-4">
                    <div className="top d-flex align-items-center justify-content-between flex-wrap gap-10 pb-3">
                      <div className="d-flex align-items-center gap-10">
                        <div
                          className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                          style={{ height: 35, width: 35, background: "#DBDBDB" }}
                        >
                          {getNameInitials(clientDetails)}
                        </div>
                        <div className="content">
                          <h6 className="m-0 themeBlue fw-sbold">{userFullName(clientDetails)}</h6>
                        </div>
                      </div>
                      {clientDetails?.client_school_detail?.client_school?.name && <div className="right">
                        <p
                          className="violetStatus status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1 bages-wrapper"
                          style={{ maxWidth: "max-content" }}
                        >
                          {clientDetails?.client_school_detail?.client_school?.name}
                        </p>
                      </div>}
                    </div>
                    <Row>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            DOB
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob ? dateFormat(clientDetails?.client_detail?.dob) : "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Age
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Gender
                          </h6>
                          <p className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.gender || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            City/Town
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.city_town || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            DTC #
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.clientMdtDetail?.dtc || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white common-border-radius clint-profile-detail h-100">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Practitioner
                          </h6>
                          <p className="m-0 themeBlue pt-2">
                            {formatString(clientDetails?.client_detail?.clientMdtDetail?.specialization)}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col> */}
                  <Col lg="12" className="my-3">
                    <NotesComponentV2
                      className={`${styles.formControl} form-control`}
                      module={CLIENT_NOTE_TYPES[clientType]}
                      client_id={clientId}
                    />
                  </Col>

                  {/* {
                    clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => {
                      if (item?.client_guardian?.client_role?.slug !== "parent") {
                        return null;
                      }
                      return (
                        <Col lg="12" className="my-1 ps-3 pe-4">
                          <div className="py-2">
                            <h6 class="m-0 themeBlue fw-bold pb-2">
                              {" "}
                              <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                ■
                              </span>{" "}
                              Parent Contact Details
                            </h6>
                            <div
                              className="cardCstm p-3  parents-detail-wrapper"
                            >
                              <Row>
                                <Col md="4" sm="6" className="my-2">
                                  <h6 class="m-0 themeBlue fw-bold">
                                    {" "}
                                    <span
                                      class=""
                                      style={{ color: " rgb(61, 160, 170)" }}
                                    >
                                      ■
                                    </span>{" "}
                                    Name
                                  </h6>
                                  <p className="m-0 themeBlue">{userFullName(item?.client_guardian) || "--"}</p>
                                </Col>
                                <Col md="4" sm="6" className="my-2">
                                  <h6 class="m-0 themeBlue fw-bold">
                                    {" "}
                                    <span
                                      class=""
                                      style={{ color: " rgb(61, 160, 170)" }}
                                    >
                                      ■
                                    </span>{" "}
                                    Phone
                                  </h6>
                                  <p className="m-0 themeBlue">{item?.client_guardian?.phone || "--"}</p>
                                </Col>
                                <Col md="4" sm="6" className="my-2">
                                  <h6 class="m-0 themeBlue fw-bold">
                                    {" "}
                                    <span
                                      class=""
                                      style={{ color: " rgb(61, 160, 170)" }}
                                    >
                                      ■
                                    </span>{" "}
                                    Email
                                  </h6>
                                  <p
                                    className="m-0 themeBlue"
                                    style={{ lineHeight: "20px", wordBreak: "break-all" }}
                                  >
                                    {item?.client_guardian?.email || "--"}
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      )
                    }
                    )} */}

                  <Col lg="12" className="my-3">

                    <div className="py-2">
                      <h6 class="m-0 themeBlue fw-bold pb-2">
                        <div className="d-flex align-items-center">
                          <div>
                            {/* {" "}
                            <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                              ■
                            </span>{" "} */}
                            Share a link
                          </div>
                          {!isEditingLinks && (
                            <CommonToolTip
                              text={"Edit"}
                              component={
                                <div>
                                  <IconButton
                                    onClick={() => setIsEditingLinks(true)}
                                  >
                                    <Edit style={{ marginLeft: "10px" }} size={15} />
                                  </IconButton>
                                </div>
                              }
                            />
                          )}
                        </div>
                      </h6>
                      <Formik
                        initialValues={{
                          doc_share_link:
                            updateObject?.doc_share_link?.split(",")?.filter(Boolean) || [""],
                        }}
                        validationSchema={shareLinkSchema}
                        onSubmit={handleSubmitShareLink}
                        enableReinitialize
                      >
                        {({ values, handleSubmit, isSubmitting }) => (
                          <Form className="align-items-center w-100" onSubmit={handleSubmit}>
                            <Row>
                              <Col lg="12">
                                {isEditingLinks ? (
                                  <FieldArray name="doc_share_link">
                                    {({ remove, push }) => (
                                      <ul className="list-unstyled ps-0 mb-0 w-100">
                                        {values.doc_share_link.length === 0 ? (
                                          <Row className="mt-2 w-100 align-items-center">
                                            <Col lg="11">
                                              <div className="w-100 d-flex">
                                                <AppInputField
                                                  type="text"
                                                  placeholder="Add link to a report"
                                                  className="form-control"
                                                  name={`doc_share_link.0`}
                                                />
                                              </div>
                                            </Col>
                                            <Col lg="1 p-0">
                                              <Button
                                                className="border-0 p-0"
                                                variant="transparent"
                                              >
                                                <PlusIcon onClick={() => push("")} />
                                              </Button>
                                            </Col>
                                          </Row>
                                        ) : (
                                          values.doc_share_link.map((area, index) => {
                                            const isLastItem =
                                              index === values.doc_share_link.length - 1;
                                            return (
                                              <Row
                                                className="mt-2 w-100 align-items-center"
                                                key={index}
                                              >
                                                <Col lg="11">
                                                  <div className="w-100 d-flex">
                                                    <AppInputField
                                                      type="text"
                                                      placeholder="Add link to a report"
                                                      className="readonly-box"
                                                      name={`doc_share_link.${index}`}
                                                    />
                                                  </div>
                                                </Col>
                                                <Col lg="1 p-0">
                                                  <Button
                                                    className="border-0 p-0"
                                                    variant="transparent"
                                                  >
                                                    {isLastItem ? (
                                                      values.doc_share_link.length > 1 ? (
                                                        <div className="d-flex">
                                                          <PlusIcon onClick={() => push("")} />
                                                          <MinusIcon
                                                            onClick={() => remove(index)}
                                                          />
                                                        </div>
                                                      ) : (
                                                        <PlusIcon onClick={() => push("")} />
                                                      )
                                                    ) : (
                                                      <MinusIcon onClick={() => remove(index)} />
                                                    )}
                                                  </Button>
                                                </Col>
                                              </Row>
                                            );
                                          })
                                        )}
                                      </ul>
                                    )}
                                  </FieldArray>
                                ) : (
                                  // view mode
                                  !isEmpty(compact(values.doc_share_link)) ? values.doc_share_link.map((link, index) => (
                                    <p className="m-0 p-3 mt-2" style={{ cursor: "default", border: "1px solid rgb(50, 93, 153)" }}>
                                      <a
                                        style={{ wordWrap: "break-word", color: "rgb(50, 93, 153)" }}
                                        href={normalizeUrl(link)}
                                        target="_blank"
                                        className=""
                                      >
                                        {link}
                                      </a>
                                    </p>
                                  )) : (
                                    <NoRecordFoundV2 />
                                  )
                                )}
                              </Col>

                              <Col lg="12 mt-2">
                                {isEditingLinks && (
                                  <LoadingButton
                                    type="submit"
                                    // style={{
                                    //   height: 40,
                                    //   minWidth: "unset",
                                    //   background: "#93278F",
                                    //   borderColor: "#071E3E",
                                    // }}
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    isLoading={isSubmitting}
                                  >
                                    Save

                                  </LoadingButton>
                                )}
                              </Col>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Col>

                  {/* <Col>
                    <div className="py-2">
                      <h6 class="m-0 themeBlue fw-bold pb-2">
                        Share a link
                      </h6>
                      {
                        clientDetails?.client_detail?.clientMdtDetail?.doc_share_link ?
                          clientDetails?.client_detail?.clientMdtDetail?.doc_share_link?.split(",")?.filter(Boolean)?.map((item, index) => {

                            return (
                              <p className="m-0 p-3 mt-2 " style={{ cursor: "default", borderRadius: 0, border: '1px solid #93278F' }}>
                                <Link
                                  style={{ wordWrap: "break-word" }}
                                  to={item}
                                  target="_blank"
                                  className="themeClr"
                                >
                                  {item}
                                </Link>
                              </p>
                            )
                          }) : <NoRecordFoundV2 />
                      }

                    </div>
                  </Col> */}
                  {/* <Col lg="12" className="my-3 px-4"> */}

                  {/* <ChatComponent
                      caseLoadId={caseLoadId}
                    /> */}
                  {/* </Col> */}

                  <Col lg="12">
                    <div className="" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                      <Row>
                        <Col lg='8'>
                          <h6 onClick={() => navigate(generatePath(MDT_CLIENT_DOCUMENTS_LIST, { clientId }))} className="mb-0 proxima-regular" style={{ marginTop: "3px" }}>DOCUMENTS
                            <span className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span>
                          </h6>
                        </Col>
                        <Col onClick={() => !isDisabled && setClientsDocumentModal(true)} lg='4' className="text-end">
                          <svg style={{ opacity: isDisabled && "0.5" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" className="mx-1"><mask id="mask0_0_12941" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{ maskType: "alpha" }}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_0_12941)"><path d="M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z" fill="#93278F"></path></g></svg>
                        </Col>
                      </Row>
                      <ClientAttachments
                        isPage={false}
                        resources={clientDetails?.clientResources || []}
                        clientId={clientId}
                        refetch={refetch}
                        clientType={clientType}
                        limit={4}
                      />
                    </div>
                  </Col>

                  <Col lg="12" className="my-2">
                    <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                      <Row>
                        <Col lg='8'>
                          <div className="d-flex gap-2">
                            <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>REPORTS
                            </h6>
                          </div>
                        </Col>
                        <Col lg='4' className="text-end">
                        </Col>
                      </Row>
                      {/* <h6 class="m-0 themeBlue fw-bold pb-2">Attachments</h6> */}
                      <div className="table-responsive">
                        <table className="w-100">
                          <thead>
                            <tr>
                              <th
                                onClick={() => handleAttachmentSort("name")}
                                className="fw-medium proxima"
                                style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                              >
                                <div className={`${attachmentSortField === 'name' && "themeBlueV2"} d-flex gap-2 align-items-center`}>
                                  NAME
                                  {/* {attachmentSortField === "name" ?
                                                    (attachmentSortOrder === "asc" ? <UpArrowIcon color={attachmentSortOrder === "asc"} /> : <DownArrowIcon color={attachmentSortOrder === "desc"} />) :
                                                    <DownArrowIcon />
                                                } */}
                                </div>
                              </th>
                              <th
                                onClick={() => handleAttachmentSort("date")}
                                className="fw-medium proxima"
                                style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                              >
                                <div className={`${attachmentSortField === 'date' && "themeBlueV2"} d-flex gap-2 align-items-center`}>
                                  DATE
                                  {/* {attachmentSortField === "date" ?
                                                    (attachmentSortOrder === "asc" ? <UpArrowIcon color={attachmentSortOrder === "asc"} /> : <DownArrowIcon color={attachmentSortOrder === "desc"} />) :
                                                    <DownArrowIcon />
                                                } */}
                                </div>
                              </th>
                              <th
                                className="fw-medium proxima"
                                style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}
                              >
                                <div className="d-flex gap-2 align-items-center">
                                  ACTION
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {reportRows.length > 0 ?
                              reportRows.map((item, index) => {
                                return (
                                  <>
                                    <tr key={index}>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <div className="d-flex align-items-center gap-10">
                                          <span className="icn flex-shrink-0">
                                            <img
                                              src={formIcn}
                                              alt=""
                                              className="img-fluid"
                                              style={{ width: "20px" }}
                                            />
                                          </span>
                                          <CommonToolTip
                                            text={item?.attachment_name || item?.assesmentType?.title}
                                            component={
                                              <p
                                                style={{
                                                  maxWidth: "250px",
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                  fontSize: "12px",
                                                  color: "#000",
                                                  margin: 0,
                                                  cursor: "pointer"
                                                }}
                                                className="proxima"
                                                role="button"
                                                onClick={() => handleViewPdf(item?.pdfList?.[0]?.attachment_key)}
                                              >
                                                {item?.assesmentType?.title || "--"}
                                              </p>
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td
                                        className="proxima"
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                          color: "#000",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {dateFormatLocal(item?.screening_date, "MMM DD, YYYY")}
                                      </td>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <div className="d-flex align-items-center gap-10">
                                          <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                            <CommonToolTip
                                              text={"View"}
                                              component={
                                                <ViewDocumentIcon
                                                  style={{ width: "15px", height: "15px", cursor: "pointer" }}
                                                  onClick={() => handleViewPdf(item?.pdfList?.[0]?.attachment_key)}
                                                />
                                              }
                                            />
                                          </div>
                                          {/* <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                          {!item?.deletedAt ?
                                            <CommonToolTip
                                              text={"Delete"}
                                              component={
                                                // <DeleteIcon
                                                //     className="cursor-pointer"
                                                //     style={{ cursor: "pointer" }}
                                                //     onClick={() => {
                                                //         setCurrentItem(item);
                                                //         setShowDeleteModal(true);
                                                //     }}
                                                // />
                                                <></>
                                              }
                                            />
                                            :
                                            <CommonToolTip
                                              text={"Retrieve"}
                                              component={
                                                <RefreshIcon
                                                  className="cursor-pointer mx-1"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    setCurrentItem(item);
                                                    setShowRestoreModal(true);
                                                  }}
                                                />
                                              }
                                            />
                                          }
                                        </div> */}
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                );
                              }) :
                              <tr>
                                <td colSpan="3" className="text-center px-0">
                                  <NoRecordFoundV2 />
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                        <div className="d-flex justify-content-center mt-2">
                          {
                            reportsList?.records?.length > 0 &&
                            <CstmPagination
                              totalPages={totalPages}
                              className={'paginationV2'}
                              activePage={currentPage}
                              handlePageChange={handlePageChange}
                            />
                          }
                        </div>
                        {/* <table className="table">
                        <tbody>
                          {
                            !clientDetails?.clientResources?.length ? <NoRecordFound /> : clientDetails?.clientResources?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td className="border-0">
                                    <div className="d-flex align-items-center gap-10">
                                      <div className="span icn flex-shrink-0">
                                        <DocumentColorIcon />
                                      </div>
                                      <div className="content">
                                        <p className="m-0 fw-bold">{item?.attachment_name}</p>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="border-0">
                                    <div className="d-flex align-items-center justify-content-center gap-10">
                                      <Button
                                        className="border-0 p-0"
                                        variant="transparent"
                                        onClick={() => handleViewPdf(item?.attachment_key)}
                                      >

                                        <EyeIcon />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          }

                        </tbody>
                      </table> */}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" className="p-0">
                <Row>
                  <Col lg="12 p-0">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-10 p-4">
                      {/* <h6 className="m-0 themeBlue fw-bold">Team Member</h6> */}
                      <h6></h6>
                      <ul className="list-unstyled mb-0 d-flex align-items-center gap-10">
                        <li className="">
                          <div
                            className="d-flex align-items-center"
                            style={{ fontSize: 14 }}
                          >
                            <h6 className="m-0 themeBlue fw-bold me-1">
                              Clinic Date
                            </h6>
                            <p className="m-0 forteen themeBlue">
                              {dateFormat(clientDetails?.client_detail?.clientMdtDetail?.clinic_date)}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="px-2">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>ASSIGNED CLINICIANS
                              </h6>
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                          </Col>
                        </Row>

                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className="w-100">
                            <thead>
                              <tr>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    THERAPIST
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", width: "120px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    DISCIPLINE
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ width: "54px", padding: "15px 10px", borderBottom: "2px solid #315D99" }}
                                >
                                  <span className="visually-hidden">Expand assessment dates</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist?.length > 0 ?
                                clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist?.map((item, index) => {
                                  const isOwner = item?.clientCaseloadMapping?.[0]?.therapist_id === user?.id;
                                  const assessmentDates = getAssessmentDates(item);

                                  const isExpanded = expandedClinicianId === item.id;

                                  return (
                                    <React.Fragment key={item.id || index}>
                                      <tr>
                                        <td className={styles.clinicianCell}>
                                          {userFullName(item?.clientCaseloadMapping?.[0]?.caseTherapist)}
                                        </td>
                                        <td className={`${styles.clinicianCell} proxima`}>
                                          {item?.caseDiscipline?.assign_term || "--"}
                                        </td>
                                        <td className={styles.expandCell}>
                                          <Button
                                            type="button"
                                            variant="transparent"
                                            className={styles.expandButton}
                                            aria-label={`${isExpanded ? "Collapse" : "Expand"} assessment dates for ${userFullName(item?.clientCaseloadMapping?.[0]?.caseTherapist)}`}
                                            aria-expanded={isExpanded}
                                            onClick={() => setExpandedClinicianId(isExpanded ? null : item.id)}
                                          >
                                            <svg className={isExpanded ? styles.arrowExpanded : styles.arrow} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                              <path d="m4 6 4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                          </Button>
                                        </td>
                                      </tr>
                                      {isExpanded && (
                                        <tr className={styles.assessmentDateRow}>
                                          <td colSpan="3">
                                            <Formik
                                              enableReinitialize
                                              initialValues={{
                                                assessmentDates: assessmentDates.reduce((dates, assessmentDateItem) => ({
                                                  ...dates,
                                                  [assessmentDateItem.id]: getAssessmentDateInputValue(assessmentDateItem?.assessment_date),
                                                }), {}),
                                                assessmentTimes: assessmentDates.reduce((times, assessmentDateItem) => ({
                                                  ...times,
                                                  [assessmentDateItem.id]: getAssessmentTimeInputValue(assessmentDateItem),
                                                }), {}),
                                                newAssessmentDate: "",
                                                assessment_time: "",
                                              }}
                                              onSubmit={() => { }}
                                            >
                                              {({ values, setFieldValue, handleSubmit }) => (
                                                <Form className={styles.assessmentDateManager} onSubmit={handleSubmit}>
                                                  {assessmentDates.length ? (
                                                    <div className={styles.assessmentDateList}>
                                                      {assessmentDates.map((assessmentDateItem) => {
                                                        const currentAssessmentDate = getAssessmentDateInputValue(assessmentDateItem?.assessment_date);
                                                        const currentAssessmentTime = getAssessmentTimeInputValue(assessmentDateItem);
                                                        const assessmentDateValue = values.assessmentDates?.[assessmentDateItem.id] || "";
                                                        const assessmentTimeValue = values.assessmentTimes?.[assessmentDateItem.id] || "";
                                                        const isEditing = editingAssessmentDates[assessmentDateItem.id];
                                                        const isAssessmentChanged = assessmentDateValue !== currentAssessmentDate || assessmentTimeValue !== currentAssessmentTime;

                                                        return (
                                                          <div className={styles.assessmentDateItem} key={assessmentDateItem.id}>
                                                            {isOwner && isEditing ? (
                                                              <>
                                                                <AppDatePicker name={`assessmentDates.${assessmentDateItem.id}`} aria-label="Assessment date" className="readonly-box" />
                                                                <AppInputField name={`assessmentTimes.${assessmentDateItem.id}`} type="time" aria-label="Assessment time" className={styles.assessmentTimeInput} />
                                                                <div className="d-flex align-items-center gap-2">
                                                                  {currentAssessmentTime && <Button type="button" className="border-0 text-danger" style={{ fontSize: "12px" }} variant="transparent" onClick={() => setFieldValue(`assessmentTimes.${assessmentDateItem.id}`, "")} disabled={updateAssessmentDateLoading}>Remove time</Button>}

                                                                  <Button type="button" className="border-0" variant="transparent" onClick={() => handleAssessmentDateSave(assessmentDateItem, assessmentDateValue, assessmentTimeValue)} disabled={!assessmentDateValue || !isAssessmentChanged || updateAssessmentDateLoading}>Save</Button>
                                                                  <Button type="button" className="border-0 themeBlueV2" variant="transparent" onClick={() => { setFieldValue(`assessmentDates.${assessmentDateItem.id}`, currentAssessmentDate); setFieldValue(`assessmentTimes.${assessmentDateItem.id}`, currentAssessmentTime); handleAssessmentDateCancel(assessmentDateItem.id); }} disabled={updateAssessmentDateLoading}>Cancel</Button>
                                                                </div>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <div className={styles.assignmentDateTime}>
                                                                  <span className="d-flex align-items-center gap-2"><Calendar size={14} /> <div>{assessmentDateItem?.assessment_date ? `${dateFormat(assessmentDateItem.assessment_date, "MMM DD, YYYY")}` : "--"}</div></span>
                                                                  <span className="d-flex align-items-center gap-2"><Clock size={14} /> <div>{assessmentDateItem.assessment_time ? dateFormat(assessmentDateItem?.assessment_time, "hh:mm A", "HH:mm:ss") : "--"}</div></span>

                                                                  {/* <span className={styles.assignmentTime}>Assessment time: {assessmentDateItem.assessment_time ? dateFormat(assessmentDateItem?.assessment_time, "hh:mm A", "HH:mm:ss") : "--"}</span> */}
                                                                </div>
                                                                {isOwner && <div className="d-flex align-items-center gap-1">
                                                                  <CommonToolTip text="Edit date" component={<Button type="button" variant="transparent" className="p-1 border-0" onClick={() => setEditingAssessmentDates((prev) => ({ ...prev, [assessmentDateItem.id]: true }))}><EditIcon /></Button>} />
                                                                  <CommonToolTip text="Delete date" component={<Button type="button" variant="transparent" className="p-1 border-0" onClick={() => { setAssessmentDateToDelete(assessmentDateItem); setModalType("delete"); setShowConfirmationModal(true); }}><DeleteIcon /></Button>} />
                                                                </div>}
                                                              </>
                                                            )}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  ) : <p className="m-0 text-muted">No assessment dates added</p>}
                                                  {isOwner && (
                                                    <div className={styles.addAssessmentDate}>
                                                      <AppDatePicker name="newAssessmentDate" aria-label="New assessment date" className={'readonly-box'} />
                                                      <AppInputField name="assessment_time" type="time" aria-label="Assessment time" className={styles.assessmentTimeInput} />
                                                      <Button type="button" className="border-0 d-flex align-items-center gap-1" variant="transparent" onClick={() => handleCreateAssessmentDate(item.id, values.newAssessmentDate, values.assessment_time, setFieldValue)} disabled={createAssessmentDateLoading}><PlusIcon /> Add date</Button>
                                                    </div>
                                                  )}
                                                </Form>
                                              )}
                                            </Formik>
                                          </td>
                                        </tr>
                                      )}
                                    </React.Fragment>
                                  );
                                }) :
                                <tr>
                                  <td colSpan="3" className="text-center px-0">
                                    <NoRecordFoundV2 />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {/* <div
                        className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-4 pb-0`}
                      >
                        <div>
                          <table
                            className={`${styles.table} table mb-0`}
                            style={{ borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr>
                                <th className="text-dark text-uppercase px-2 fw-bold bg-transparent caption-font-size">
                                  User
                                </th>
                                <th className="text-dark text-uppercase px-2 fw-bold bg-transparent caption-font-size">
                                  discipline
                                </th>
                                <th className="text-dark text-uppercase  px-2 fw-bold bg-transparent caption-font-size">
                                  Assessment Dates
                                </th>
                                <th className="text-dark text-uppercase px-2 fw-bold bg-transparent caption-font-size">
                                  meeting Time
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist?.map((item, index) => {
                                  return (
                                    <tr>
                                      <td className="p-2">
                                        <h6 className="fw-sbold themeBlue m-0">
                                          {userFullName(item?.clientCaseloadMapping[0]?.caseTherapist)}
                                        </h6>
                                      </td>
                                      <td className="p-2">{item?.caseDiscipline?.assign_term || "--"}</td>
                                      <td className="p-2">
                                        <Button
                                          className="border-0 p-0 d-flex align-items-center  themeBlue fw-sbold"
                                          variant="transparent"
                                        >
                                          {" "}
                                          <span className="icn me-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="16"
                                              viewBox="0 0 14 16"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.75 15.5C1.3375 15.5 0.984375 15.3531 0.690625 15.0594C0.396875 14.7656 0.25 14.4125 0.25 14V3.5C0.25 3.0875 0.396875 2.73438 0.690625 2.44063C0.984375 2.14688 1.3375 2 1.75 2H2.5V0.5H4V2H10V0.5H11.5V2H12.25C12.6625 2 13.0156 2.14688 13.3094 2.44063C13.6031 2.73438 13.75 3.0875 13.75 3.5V14C13.75 14.4125 13.6031 14.7656 13.3094 15.0594C13.0156 15.3531 12.6625 15.5 12.25 15.5H1.75ZM1.75 14H12.25V6.5H1.75V14ZM1.75 5H12.25V3.5H1.75V5ZM7 9.5C6.7875 9.5 6.60938 9.42813 6.46563 9.28438C6.32188 9.14062 6.25 8.9625 6.25 8.75C6.25 8.5375 6.32188 8.35938 6.46563 8.21563C6.60938 8.07188 6.7875 8 7 8C7.2125 8 7.39063 8.07188 7.53438 8.21563C7.67813 8.35938 7.75 8.5375 7.75 8.75C7.75 8.9625 7.67813 9.14062 7.53438 9.28438C7.39063 9.42813 7.2125 9.5 7 9.5ZM4 9.5C3.7875 9.5 3.60938 9.42813 3.46562 9.28438C3.32187 9.14062 3.25 8.9625 3.25 8.75C3.25 8.5375 3.32187 8.35938 3.46562 8.21563C3.60938 8.07188 3.7875 8 4 8C4.2125 8 4.39062 8.07188 4.53438 8.21563C4.67812 8.35938 4.75 8.5375 4.75 8.75C4.75 8.9625 4.67812 9.14062 4.53438 9.28438C4.39062 9.42813 4.2125 9.5 4 9.5ZM10 9.5C9.7875 9.5 9.60938 9.42813 9.46563 9.28438C9.32188 9.14062 9.25 8.9625 9.25 8.75C9.25 8.5375 9.32188 8.35938 9.46563 8.21563C9.60938 8.07188 9.7875 8 10 8C10.2125 8 10.3906 8.07188 10.5344 8.21563C10.6781 8.35938 10.75 8.5375 10.75 8.75C10.75 8.9625 10.6781 9.14062 10.5344 9.28438C10.3906 9.42813 10.2125 9.5 10 9.5ZM7 12.5C6.7875 12.5 6.60938 12.4281 6.46563 12.2844C6.32188 12.1406 6.25 11.9625 6.25 11.75C6.25 11.5375 6.32188 11.3594 6.46563 11.2156C6.60938 11.0719 6.7875 11 7 11C7.2125 11 7.39063 11.0719 7.53438 11.2156C7.67813 11.3594 7.75 11.5375 7.75 11.75C7.75 11.9625 7.67813 12.1406 7.53438 12.2844C7.39063 12.4281 7.2125 12.5 7 12.5ZM4 12.5C3.7875 12.5 3.60938 12.4281 3.46562 12.2844C3.32187 12.1406 3.25 11.9625 3.25 11.75C3.25 11.5375 3.32187 11.3594 3.46562 11.2156C3.60938 11.0719 3.7875 11 4 11C4.2125 11 4.39062 11.0719 4.53438 11.2156C4.67812 11.3594 4.75 11.5375 4.75 11.75C4.75 11.9625 4.67812 12.1406 4.53438 12.2844C4.39062 12.4281 4.2125 12.5 4 12.5ZM10 12.5C9.7875 12.5 9.60938 12.4281 9.46563 12.2844C9.32188 12.1406 9.25 11.9625 9.25 11.75C9.25 11.5375 9.32188 11.3594 9.46563 11.2156C9.60938 11.0719 9.7875 11 10 11C10.2125 11 10.3906 11.0719 10.5344 11.2156C10.6781 11.3594 10.75 11.5375 10.75 11.75C10.75 11.9625 10.6781 12.1406 10.5344 12.2844C10.3906 12.4281 10.2125 12.5 10 12.5Z"
                                                fill="#1C1B1F"
                                              />
                                            </svg>
                                          </span>
                                          {item?.assessment_date ? dateFormat(item?.assessment_date) : "--"}
                                        </Button>
                                      </td>
                                      <td className="p-2">
                                        {item?.meeting_time ? dateFormat(item?.meeting_time, "hh:mm A", "HH:mm:ss") : "--"}

                                      </td>
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </table>
                        </div>
                      </div> */}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="px-2">

                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>CHECKLIST
                                {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                              </h6>
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            {/* <AddPlus isDisabled={isDisabled} onClick={() => !isDisabled && setAssignDisciplineModal(true)} /> */}
                          </Col>
                        </Row>
                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className="w-100">
                            <thead>
                              <tr>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    THERAPIST NAME
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", width: "120px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    ACTION ITEM
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div className={`d-flex gap-2 align-items-center`}>
                                    DEADLINE
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div className={`d-flex gap-2 align-items-center`}>
                                    STATUS
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {true > 0 ?
                                clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist?.map((caseLoad) => {
                                  const isOwner = caseLoad?.clientCaseloadMapping?.[0]?.therapist_id === user?.id;
                                  return caseLoad?.caseloadChecklist?.map((checkList, index) => {
                                    return (
                                      <tr key={index}>
                                        <td
                                          style={{
                                            padding: "15px 10px",
                                            borderRadius: 0,
                                            borderBottom: "1px solid #8F8F8F",
                                          }}
                                        >
                                          <div className="d-flex gap-2 align-items-center">
                                            <img
                                              src={caseLoad?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                              alt=""
                                              className="img-fluid object-fit-cover rounded-circle border border-white"
                                              style={{ height: 30, width: 30 }}
                                            />
                                            <p className="p-0 m-0">
                                              {userFullName(caseLoad?.clientCaseloadMapping?.[0]?.caseTherapist)}
                                            </p>
                                          </div>
                                        </td>
                                        <td
                                          className="proxima"
                                          style={{
                                            padding: "15px 10px",
                                            borderRadius: 0,
                                            borderBottom: "1px solid #8F8F8F",
                                          }}
                                        >
                                          <p className="p-0 m-0">
                                            {checkList?.action || "--"}
                                          </p>
                                        </td>
                                        <td
                                          style={{
                                            padding: "15px 10px",
                                            borderRadius: 0,
                                            borderBottom: "1px solid #8F8F8F",
                                          }}
                                        >
                                          <p className="m-0 fw-sbold themeBlue">{checkList?.deadline ? dateFormat(checkList?.deadline, "MMM DD, YYYY") : "--"}</p>
                                        </td>
                                        <td
                                          style={{
                                            padding: "15px 10px",
                                            borderRadius: 0,
                                            borderBottom: "1px solid #8F8F8F",
                                          }}
                                        >
                                          {isOwner ? (
                                            <Form.Select
                                              className="form-control"
                                              aria-label="Default select example"
                                              value={checkList.status}
                                              onChange={e => {

                                                setCurrentItem({ ...checkList, new_status: parseInt(e.target.value), caseload_therapist_id: caseLoad.id });
                                                setModalType("update");
                                                setShowConfirmationModal(true);
                                              }}
                                              disabled={!isOwner}
                                            >
                                              {
                                                checkListStatusList?.map((item, index) => {
                                                  return <option key={index} value={item.id}>{item?.title}</option>
                                                })
                                              }
                                            </Form.Select>
                                          ) : (
                                            <>
                                              {checkListStatusList.find(item => item.id === checkList.status)?.title}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                }) :
                                <tr>
                                  <td colSpan="4" className="text-center px-0">
                                    <NoRecordFoundV2 />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {/* <h5 className="m-0 themeBlue fw-bold pb-2">Checklist</h5> */}
                    {/* <div
                      className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 clint-table-wrapper  py-2 pb-0`}
                    >
                      <table
                        className={`${styles.table} table  mb-0`}
                        style={{ borderCollapse: "collapse" }}
                      >
                        <thead className="mb-3">
                          <tr>
                            <th className="text-dark fw-bold border-0 text-uppercase caption-font-size table-bg-wrapper">
                              Therapist Name
                            </th>
                            <th className="text-dark fw-bold border-0 text-uppercase caption-font-size table-bg-wrapper">
                              Action Item
                            </th>
                            <th className="text-dark fw-bold border-0 text-uppercase caption-font-size table-bg-wrapper">
                              Deadline
                            </th>
                            <th className="text-dark fw-bold border-0 text-uppercase caption-font-size table-bg-wrapper">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className="border-1">
                          {
                            clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist?.map((caseLoad) => {
                              const isOwner = caseLoad?.clientCaseloadMapping?.[0]?.therapist_id === user?.id;
                              return caseLoad?.caseloadChecklist?.map((checkList, index) => {
                                return (
                                  <tr>
                                    <td className="p-2">
                                      <div className="d-flex align-items-center gap-10">
                                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center ">
                                          <li className="" style={{ marginLeft: -5 }}>
                                            <img
                                              src={caseLoad?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                              alt=""
                                              className="img-fluid object-fit-cover rounded-circle border border-white"
                                              style={{ height: 30, width: 30 }}
                                            />
                                          </li>
                                        </ul>
                                        <h6 className="m-0 themeBlue fw-sbold">
                                          {userFullName(caseLoad?.clientCaseloadMapping?.[0]?.caseTherapist)}
                                        </h6>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <p className="m-0 fw-sbold themeBlue">
                                        <span className="icn me-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="9"
                                            height="9"
                                            viewBox="0 0 9 9"
                                            fill="none"
                                          >
                                            <circle
                                              cx="4.5"
                                              cy="4.5"
                                              r="4"
                                              fill="white"
                                              stroke="#00C874"
                                            />
                                          </svg>
                                        </span>{" "}
                                        {checkList?.action || "--"}
                                      </p>
                                    </td>
                                    <td className="p-2">
                                      <p className="m-0 fw-sbold themeBlue">{checkList?.deadline ? dateFormat(checkList?.deadline, "DD/MM/YYYY") : "--"}</p>
                                    </td>
                                    <td
                                      className="rounded-0 p-2"
                                    >
                                      {isOwner ? (
                                        <Form.Select
                                          className="form-control"
                                          aria-label="Default select example"
                                          value={checkList.status}
                                          onChange={e => {

                                            setCurrentItem({ ...checkList, new_status: parseInt(e.target.value), caseload_therapist_id: caseLoad.id });
                                            setModalType("update");
                                            setShowConfirmationModal(true);
                                          }}
                                          disabled={!isOwner}
                                        >
                                          {
                                            checkListStatusList?.map((item, index) => {
                                              return <option key={index} value={item.id}>{item?.title}</option>
                                            })
                                          }
                                        </Form.Select>
                                      ) : (
                                        <>
                                          {checkListStatusList.find(item => item.id === checkList.status)?.title}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                )
                              })
                            })
                          }
                        </tbody>
                      </table>
                    </div> */}
                  </Col>
                  {/* <Col lg="12" className="my-2">
                    <h5 className="m-0 themeBlue fw-bold pb-2">MDT Terms</h5>
                    <div
                      className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                    >
                      <table className={`${styles.table} table mb-0`}>
                        <thead>
                          <tr>
                            <th className="text-dark fw-bold border-0">
                              MDt Title
                            </th>
                            <th className="text-dark fw-bold border-0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="">
                              <h6 className="m-0 fw-sbold themeBlue">
                                Report proofread
                              </h6>
                            </td>
                            <td className="">
                              <input
                                type="checkbox"
                                style={{ height: 20, width: 20 }}
                                className="form-check"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col> */}
                </Row>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};

export default MultidisciplinaryDetail;
